import { Post } from '../../store/post';
import { PostChildrenListParams } from '../../store/post/children';
import { PaginatedResponse } from '../../store/types';
import {
  DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate,
} from '../fetch';

interface AddressItem {
  id: number;
  name: string;
}

export interface Country extends AddressItem {
  iso3: string;
}

export interface State extends AddressItem {
  countryCode: string;
}

export interface City extends AddressItem {
  stateCode: string;
}
export const usePostChildrenList = (parentId: string): FetchGet<
  PaginatedResponse<Post>, PostChildrenListParams, DefaultFetchError> => (
  useFetchGet(`posts/${parentId}/children`, { autoStart: false, startStateLoading: false })
);

export const usePostCreate = (): FetchCreate<Partial<Post>, DefaultFetchError> => (
  useFetchCreate('posts', { autoStart: false, startStateLoading: false })
);

export const usePostUpdate = (postId: string): FetchUpdate<
  FetchSuccess, DefaultFetchError, { text: string, fileIds: string[] }> => (
  useFetchUpdate(`posts/${postId}`, '', { autoStart: false, startStateLoading: false })
);

export const usePostDelete = (postId: string): FetchDelete<Post, DefaultFetchError> => (
  useFetchDelete(`posts/${postId}`, '', { autoStart: false, startStateLoading: false })
);

export const usePostReaction = (): FetchCreate<
  { id: string }, DefaultFetchError, { status: boolean, postId: string }> => (
  useFetchCreate('post-reactions', { autoStart: false, startStateLoading: false })
);

export const usePostReactionDelete = (): FetchDelete<{ id: string }, DefaultFetchError> => (
  useFetchDelete('post-reactions', '', { autoStart: false, startStateLoading: false })
);

export const usePostGetById = (id?: string): FetchGetId<Post, DefaultFetchError> => (
  useFetchGetId('posts', id, { authorization: false })
);

interface ParamsWithSearch {
  search?: string;
}

export const useCountries = (params?: ParamsWithSearch): FetchGet<
  PaginatedResponse<Country>,
  ParamsWithSearch,
  DefaultFetchError
> => (
  useFetchGet('countries', {
    autoStart: true, startStateLoading: false, authorization: false, params,
  })
);
export const useStates = (params?: ParamsWithSearch): FetchGet<
  PaginatedResponse<State>,
  ParamsWithSearch,
  DefaultFetchError
> => (
  useFetchGet('states', {
    autoStart: true, startStateLoading: false, authorization: false, params,
  })
);
export const useCity = (params?: ParamsWithSearch): FetchGet<
  PaginatedResponse<City>,
  ParamsWithSearch,
  DefaultFetchError
> => (
  useFetchGet('cities', {
    autoStart: true, startStateLoading: false, authorization: false, params,
  })
);
